export default function isInViewport(elem) {
    const bounding = elem.getBoundingClientRect();
    return bounding.top <= (window.innerHeight || document.documentElement.clientHeight);
}
